import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.conseil-municipal', {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
        430: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 15
        }
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});